// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2H1V19H12.5V6.5H23V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5 20H5V22H12.5V20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.5 8.5H24V22H14.5V8.5ZM18.248 16.998V19.002H20.252V16.998H18.248Z"}}]};

const DeviceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'device-filled',
    ref,
    icon: element,
  },
));

DeviceFilledIcon.displayName = 'DeviceFilledIcon';

export default DeviceFilledIcon;
